module.exports = __webpack_public_path__ + "static/trailbutter-logo-d43ff4ef971fb7ed94740fdf547119d2.png";